import {useState,useEffect} from 'react'
import { useFetchData } from '../../hooks/useFetchData';
import { Button, Modal } from 'react-bootstrap';
import { useMutateData } from '../../hooks/useMutateData';
import DOMPurify from 'dompurify';

const UpdateHouseDetails = ({ dataToUpdate, show, onHide }) => {
    const [houseDetailsToUpdate, setHouseDetailsToUpdate] =
    useState(dataToUpdate ? dataToUpdate : null);
  const user = JSON.parse(localStorage.getItem("user"));
    
  const sanitizeInput = (input) => {
    return DOMPurify.sanitize(input);
  };
  const { data: houseCategories } = useFetchData(
    ["house-categories"],
    "houses/categories",
    true,
    user
    );
    const { data: houseStatuses } = useFetchData(
      ["house-statuses"],
      "houses/statuses",
      true,
      user
    );
    useEffect(() => {
        setHouseDetailsToUpdate(dataToUpdate)
    }, [dataToUpdate])
    // handle update house details
    const { mutate } = useMutateData();
    const updateHouseDetails = async (e) => {
      e.preventDefault();
      const postUrl = `houses`;
      const successMessage = "house updated successfully";
      const keyToInvalidate = ["house-for-account", "fetch-acount"];
      try {
        await mutate({
          url: postUrl,
          payload: houseDetailsToUpdate,
          queryKeyToInvalidate: keyToInvalidate,
          successMessage,
          method: "PUT",
        });
        onHide();
      } catch (error) {
        console.log(error);
      }
    };
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={onHide}>
          <h5>Change House Details</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <label className='ml-2'>Category</label>
          <select
            className='form-control input-select'
            onChange={(e) => {
              const { value, options } = e.target;
              const label = options[options.selectedIndex].label;
              setHouseDetailsToUpdate({
                ...houseDetailsToUpdate,
                category: {
                  id: sanitizeInput(value),
                  name: label,
                },
              });
            }}
          >
            <option>{houseDetailsToUpdate?.category.name}</option>
            {houseCategories?.map((category) => (
              <>
                <option key={category?.id} value={category?.id}>
                  {category?.name}
                </option>
              </>
            ))}
          </select>
          <label className='ml-2'>House status</label>
          <select
            className='form-control input-select'
            onChange={(e) => {
              const { value, options } = e.target;
              const label = options[options.selectedIndex].label;
              setHouseDetailsToUpdate({
                ...houseDetailsToUpdate,
                status: {
                  id: sanitizeInput(value),
                  name: label,
                },
              });
            }}
          >
            <option>{houseDetailsToUpdate?.status.name}</option>
            {houseStatuses?.map((status) => (
              <>
                <option key={status?.id} value={status?.id}>
                  {status?.name}
                </option>
              </>
            ))}
          </select>
          <label className='ml-2'>Monthly Fee</label>
          <input
            placeholder='Monthly Fee'
            className='form-control input-select mb-2'
            value={houseDetailsToUpdate?.securityFeeAmount}
            name='securityFeeAmount'
            onChange={(e) => {
              const { value } = e.target;
              setHouseDetailsToUpdate({
                ...houseDetailsToUpdate,
                securityFeeAmount: sanitizeInput(value),
              });
            }}
          />
          <div className='d-flex justify-content-center'>
            <Button className='custom-btn-color' onClick={updateHouseDetails}>
              Save Changes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UpdateHouseDetails